import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

import { ref, computed, onMounted, onUnmounted, watch } from "vue";
import { Icon } from "@iconify/vue";
import type { Size } from "./types";

interface Props {
  triggerText?: string;
  placement?: "bottom-start" | "bottom-end" | "top-start" | "top-end";
  size?: Size;
  disabled?: boolean;
  closeOnSelect?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Dropdown',
  props: {
    triggerText: {},
    placement: { default: "bottom-start" },
    size: { default: "md" },
    disabled: { type: Boolean, default: false },
    closeOnSelect: { type: Boolean, default: true }
  },
  emits: ["open", "close"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const isOpen = ref(false);
const dropdownRef = ref<HTMLElement | null>(null);
const menuRef = ref<HTMLElement | null>(null);

const triggerClasses = computed(() => {
  const classes = ["ui-dropdown__button"];
  classes.push(`ui-dropdown__button--${props.size}`);
  if (props.disabled) classes.push("ui-dropdown__button--disabled");
  return classes;
});

const menuClasses = computed(() => {
  const classes = ["ui-dropdown__menu"];
  classes.push(`ui-dropdown__menu--${props.placement}`);
  return classes;
});

const menuStyles = computed(() => {
  return {};
});

const toggle = () => {
  if (props.disabled) return;

  if (isOpen.value) {
    close();
  } else {
    open();
  }
};

const open = () => {
  isOpen.value = true;
  emit("open");
};

const close = () => {
  isOpen.value = false;
  emit("close");
};

const handleClickOutside = (event: MouseEvent) => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target as Node)) {
    close();
  }
};

const handleMenuClick = (event: MouseEvent) => {
  if (props.closeOnSelect) {
    const target = event.target as HTMLElement;
    if (target.classList.contains("ui-dropdown__item") || target.closest(".ui-dropdown__item")) {
      close();
    }
  }
};

watch(isOpen, (value) => {
  if (value && menuRef.value) {
    menuRef.value.addEventListener("click", handleMenuClick);
  }
});

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
  if (menuRef.value) {
    menuRef.value.removeEventListener("click", handleMenuClick);
  }
});

__expose({ open, close, toggle });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "ui-dropdown",
    ref_key: "dropdownRef",
    ref: dropdownRef
  }, [
    _createElementVNode("div", {
      class: "ui-dropdown__trigger",
      onClick: toggle
    }, [
      _renderSlot(_ctx.$slots, "trigger", {}, () => [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(triggerClasses.value)
        }, [
          _renderSlot(_ctx.$slots, "trigger-content", {}, () => [
            _createTextVNode(_toDisplayString(__props.triggerText), 1)
          ]),
          _createVNode(_unref(Icon), {
            icon: "mdi:chevron-down",
            class: _normalizeClass({ 'rotate-180': isOpen.value })
          }, null, 8, ["class"])
        ], 2)
      ])
    ]),
    _createVNode(_Transition, { name: "dropdown" }, {
      default: _withCtx(() => [
        (isOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref_key: "menuRef",
              ref: menuRef,
              class: _normalizeClass(menuClasses.value),
              style: _normalizeStyle(menuStyles.value)
            }, [
              _renderSlot(_ctx.$slots, "default")
            ], 6))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 512))
}
}

})